goog.provide("shadow.js.shim.module$ol$style$Style$default");
shadow.js.shim.module$ol$style$Style$default = shadow.js.require(173, {}).default;
